import React, { useCallback, useEffect, useState } from "react";
import DefaultCrudForm from "../DefaultCrudForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import useNotification from "notification";

export default function DefaultEntityCrud({
    EntityClass,
    children,
    routeForm,
    initialValuesStart,
    overSave,
    afterSave,
    beforeSave,
    ...othersProps
}) {
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState(initialValuesStart);
    const { showSuccess, showWarning } = useNotification();
    const [searchParams] = useSearchParams();
    const searchUid = searchParams.get("uid");

    const setNewValues = useCallback(async () => {
        let entity = await EntityClass.create();
        console.log("setInitialValues", entity.data);
        if (initialValuesStart) {
            setInitialValues(initialValues);
        } else {
            setInitialValues(entity.data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [EntityClass]);

    useEffect(() => {
        let observer = null;
        if (searchUid) {
            observer = EntityClass.onSnapshot(searchUid, (obj) => {
                setInitialValues(obj);
            });
        } else {
            setNewValues();
        }

        return () => {
            if (observer) {
                observer();
            }
        };
    }, [EntityClass, searchUid, setNewValues]);

    const saveValues = (values) => {

        let isNewRecord = !values.uid ? true : false;
     
        if (beforeSave) {
            let continua = beforeSave(values, isNewRecord);
            if (!continua) {
                return;
            }
        }
        if (overSave) {
            overSave(values);
        } else {
            let entity = new EntityClass();
            entity.update(values);

            entity.save().then(() => {
                showSuccess("Salvo com Sucesso");
                if (afterSave) {
                    afterSave(values, isNewRecord);
                }
                if (routeForm) {
                    // console.log("routeForm", routeForm)
                    navigate("/" + routeForm + "?uid=" + entity.data.uid);
                }
            });
        }
    };
    const validValues = async (values) => {
        let errors = await EntityClass.validFieldErrors(values);

        if (errors) {
            if (errors.length) {
                console.log("errors aaaaaa", errors);
                showWarning(errors?.join("\n"));
                return false;
            }
        }

        return true;
    };

    return (
        <DefaultCrudForm
            saveValues={saveValues}
            validValues={validValues}
            initialValues={initialValues}
            setNewValues={setNewValues}
            routeForm={routeForm || ""}
            EntityClass={EntityClass}
            {...othersProps}
        >
            {(formProps) => children(formProps)}
        </DefaultCrudForm>
    );
}
